import { getField, updateField } from 'vuex-map-fields';
import OnlineScheduling from '../../api/online-scheduling';

// initial state
const state = {
    clinicUrl: null,
    step: 1,
    appointmentType: null,
    loading: true,
    clinic: null,
    patient: null,
    timeslot: null,
    appointments: [],
    companionTypes: [],
    globals: {
        changeLocations: 'locations',
        returnToHomepage: '',
    }
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    resetData({ commit }) {
        commit('setStateValue', { key: 'clinicUrl', value: null });
        commit('setStateValue', { key: 'appointmentType', value: null });
        commit('setStateValue', { key: 'loading', value: true });
        commit('setStateValue', { key: 'clinic', value: null });
        commit('setStateValue', { key: 'patient', value: null });
        commit('setStateValue', { key: 'timeslot', value: null });
        commit('setStateValue', { key: 'appointments', value: [] });
        commit('setStateValue', { key: 'companionTypes', value: [] });
        commit('setStateValue', { key: 'step', value: 1 });
    },
    getClinicInformation({ commit, rootState }, { clinicUrl, dealerId, clientToken, cb }) {
        OnlineScheduling.getClinicInformation((data) => {
            commit('setStateValue', { key: 'clinic', value: data.data[0] });
            if (cb) {
                cb();
            }
        }, { clinicUrl, dealerId, clientToken });
    },
    getAppointmentTimeslots({ commit, rootState }, { startDate, endDate, appointmentType, clinicId, dealerId, clientToken, cb }) {
        OnlineScheduling.getAppointmentTimeslots((data) => {
            commit('setStateValue', { key: 'appointments', value: data });
            if (cb) {
                cb();
            }
        }, { startDate, endDate, appointmentType, clinicId, dealerId, clientToken });
    },
    getCompanionTypes({ commit, rootState }, { dealerId, clientToken, cb }) {
        OnlineScheduling.getCompanionTypes((data) => {
            commit('setStateValue', { key: 'companionTypes', value: data });
            if (cb) {
                cb();
            }
        }, { dealerId, clientToken });
    },
    postScheduleAppointment({ commit, rootState }, { data, dealerId, clientToken, cb }) {
        OnlineScheduling.postScheduleAppointment((data) => {
            if (cb) {
                cb();
            }
        }, { data, dealerId, clientToken });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
